import styles from './NotFoundBlock.module.scss'

let NotFoundBlock = () => {
    return (
        <div className={styles.root}><span>Ничего не найдено :(</span></div>
    )
}

export default NotFoundBlock;